import React, {lazy} from "react";
import DbBase from "app/pages/db/DbBase";
const DbUserConfig = lazy(() => import("../pages/db/user/DbUserConfig"));
const DbUserToDoList = lazy(() => import("../pages/db/user/DbUserToDoList"));
const DbUserPower = lazy(() => import("../pages/db/user/DbUserPower"));
const DbUserRe = lazy(() => import("../pages/db/user/DbUserRe"));
const DbUserCarbon = lazy(() => import("../pages/db/user/DbUserCarbon"));
const DbUserMarket = lazy(() => import("../pages/db/user/DbUserMarket"));
const DbUserCustom = lazy(() => import("../pages/db/user/DbUserCustom"));

export const dbRouter: any = [
  {path: "/db", element: <DbBase /> },
  {path: "/db/user/config", element: <DbUserConfig/>},
  {path: "/db/user/custom", element: <DbUserCustom/>},
  {path: "/db/user/todo", element: <DbUserToDoList/>},
  {path: "/db/user/power", element: <DbUserPower/>},
  {path: "/db/user/re100", element: <DbUserRe/>},
  {path: "/db/user/carbon", element: <DbUserCarbon/>},
  {path: "/db/user/market", element: <DbUserMarket/>},
];
